import React, { useState } from "react";
import { FloatLabel } from "primereact/floatlabel";
import { InputText } from "primereact/inputtext";
import PropTypes from "prop-types";
import SimpleModal from "./SimpleModal";
import { useToast } from "../ToastProvider";
import { router } from "../../data/Services/ordersRouter";
import { useAuthStore } from "../../store/authStore";
import { formatDocument, cleanDocument } from "../../utils/documentUtils";

function ForgotPasswordModal({ visible, onHide }) {
  const { showSuccess, showError } = useToast();
  const { getUsername, getBroker } = useAuthStore();
  const [docValue, setDocValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleDocumentChange = (e) => {
    const formatted = formatDocument(e.target.value);
    setDocValue(formatted);
  };

  const handleSubmit = async () => {
    if (!docValue.trim()) {
      showError("Por favor, digite seu CPF ou CNPJ", "Campo obrigatório");
      return;
    }

    const username = getUsername();
    const broker = getBroker();

    if (!username) {
      showError(
        "Usuário não encontrado. Faça login no MarketData primeiro.",
        "Erro de autenticação",
      );
      return;
    }

    if (!broker) {
      showError(
        "Corretora não encontrada. Faça login no MarketData primeiro.",
        "Erro de autenticação",
      );
      return;
    }

    setIsLoading(true);

    try {
      const cleanedDocument = cleanDocument(docValue);
      const result = await router.forgotPwd(broker, username, cleanedDocument);

      if (result === "OK") {
        showSuccess(
          "Um e-mail com instruções de alteração de senha foi enviado para você!",
          "Sucesso",
        );
        setDocValue("");
        if (onHide) onHide();
      } else if (result === "FAIL") {
        showError(
          "Por favor, entre em contato com nossa central de suporte!",
          "Erro",
        );
      } else if (result) {
        showError(result, "Erro");
      } else {
        showError("Erro ao processar solicitação. Tente novamente.", "Erro");
      }
    } catch (error) {
      console.error("Forgot password error:", error);
      showError(
        error.message || "Erro inesperado ao processar solicitação",
        "Erro",
      );
    } finally {
      setIsLoading(false);
    }
  };

  const currentBroker = getBroker();

  // Broker names mapping
  const getBrokerName = (brokerCode) => {
    const brokerNames = {
      XPI: "XP Investimentos",
      CLEAR: "Clear Corretora",
      TZ: "TradeZone",
      RICO: "Rico Investimentos",
      SIMULATOR: "Simulador",
    };
    return brokerNames[brokerCode] || brokerCode;
  };

  return (
    <SimpleModal
      title="Esqueci Minha Senha!"
      visible={visible}
      onHide={onHide}
      onConfirm={handleSubmit}
      confirmLabel={isLoading ? "Enviando..." : "Enviar Email de Recuperação"}
      showCancel={!isLoading}
      size="small"
      variant="form"
    >
      <div className="forgot-password-form">
        <div
          className="broker-forgot-password"
          style={{
            marginBottom: "10px",
            padding: "8px 10px",
            backgroundColor: "var(--surface-section)",
            borderRadius: "4px",
            fontSize: "12px",
          }}
        >
          <strong>Broker:</strong>{" "}
          {getBrokerName(currentBroker) || "Não definida"}
        </div>
        <div className="p-field full-width">
          <FloatLabel className="float-section">
            <InputText
              id="cpf"
              value={docValue}
              onChange={handleDocumentChange}
              disabled={isLoading}
              data-evo-id="forgotpasswordmodal-input-cpf"
            />
            <label htmlFor="cpf">CPF / CNPJ</label>
          </FloatLabel>
        </div>
      </div>
    </SimpleModal>
  );
}

ForgotPasswordModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
};

export default ForgotPasswordModal;
